import { IonContent, IonHeader, IonPage } from "@ionic/react";
import { useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import EditUserGrid from "../components/EditUserGrid";
import Footer from "../components/Footer";
import RouteText from "../components/RouteText";
import Toolbar from "../components/Toolbar";
import AppContext from "../providers/AppContext";

const NewUser: React.FC<RouteComponentProps> = props => {
  const appContext = useContext(AppContext);

  useEffect(() => {
    if (appContext.jwt === "") {
      // browser refreshed so move back to landing
      props.history.replace("/");
    }
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <Toolbar props={props} />
      </IonHeader>
      <IonContent>
        <div className="pageContainer">
          <div className="pageContentContainer">
            <RouteText
              routes={[
                { name: "Dashboard", route: "/" },
                { name: "User Management", route: "/user-management" },
              ]}
              currentLocation="New User"
              routeProps={props}
            />
            <EditUserGrid forNewUser={true} />
          </div>
          <Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NewUser;
